export default __webpack_public_path__ + "media/images/archetypes/lurker-0bcd681f0f61a27330eb75a786f7a113.png";